export default "__VITE_ASSET__2329daee__"